/**
 * Card — 콘텐츠를 감싸는 흰색 컨테이너 카드
 *
 * title과 extra(우측 액션 영역)가 있을 때 헤더 섹션을 자동으로 렌더링한다.
 */

import { ReactNode } from 'react'
import { cn } from '../../lib/cn.js'
import styles from './Card.module.css'

interface CardProps {
  /** 카드 헤더 제목 텍스트 */
  title?: string
  /** 헤더 우측에 배치할 노드 (버튼, 뱃지 등) */
  extra?: ReactNode
  className?: string
  children: ReactNode
}

export function Card({ title, extra, className, children }: CardProps) {
  const hasHeader = Boolean(title ?? extra)

  return (
    <div className={cn(styles.root, className)}>
      {hasHeader && (
        <div className={styles.header}>
          {title && <h3 className={styles.title}>{title}</h3>}
          {extra && <div className={styles.extra}>{extra}</div>}
        </div>
      )}
      <div className={styles.body}>{children}</div>
    </div>
  )
}
